var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.426 4.988 3.528 3.528-4.134 4.135a4.7 4.7 0 0 1-3.326 1.377H2.457a.543.543 0 0 1-.543-.543V12.45c0-1.248.496-2.445 1.378-3.327zm3.257-3.257-.954.954 3.528 3.529.854-.854c.922-.923 1.1-2.427.273-3.438a2.495 2.495 0 0 0-3.7-.191"
})));
export { SvgPencil as ReactComponent };
export default __webpack_public_path__ + "17ed96ebc4af9f836a7cdb14b84824cd.svg";